import { Axios } from '../utils/http';
let baseURL = 'https://www.szshuwei.com/api';
if (process.env.NODE_ENV === 'development') {
    // 开发
    baseURL = '/officialBase';
}
// 上传图片
export function uploadFile(data) {
    return Axios.post(baseURL + `/file/upload`, data).then(res => res.data);
}
//数据保存
export function updateById(data) {
    return Axios.post(baseURL + `/componentContext/updateById`, data).then(res => res.data);
}
//获取数据
export function pageQuery(data) {
    return Axios.post(baseURL + `/componentContext/pageQuery`, data).then(res => res.data);
}
//获取文章列表
export function newList(data) {
    return Axios.post(baseURL + `/article/pageQuery`, data).then(res => res.data);
}
//获取文章详情
export function newsDetails(id) {
    return Axios.get(baseURL + `/article/detail/${id}`).then(res => res.data.data);
}
//获取文字类型列表

export function getByBusinessId(data) {
    return Axios.post(baseURL + `/articleColumn/getByBusinessId`, data).then(res => res.data);
}

// 提交留咨表单
export function saveBrand(data) {
    return Axios.post(baseURL + `/tblApplySettleIn/saveBrand`, data).then(res => res.data);
}
